define('views/parts/form/chatbox',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'summernote', 'bootbox',
    // collections
    'collections/conversation/custom-messages',
    // services
    'services/api',
    'services/i18n',
    'services/user',
    'services/toastr-service',
    // views
    'views/parts/form/button',
    'views/parts/modal/login-with-zoom-modal',
    'views/parts/modal/zoom-meeting-created-modal',
    'views/modules/attachment/attachment-list',
    // events
    'services/events/conversation-events',
    'services/events/user-events',
    // templates
    'text!templates/parts/form/chatbox.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Summernote, Bootbox,
    // collections
    CCustomMessages,
    // services
    API,
    i18n,
    User,
    ToastrService,
    // views
    VButton,
    VLoginWithZoomModal,
    VZoomMeetingCreatedModal,
    VAttachmentList,
    // events
    ConversationEvents,
    UserEvents,
    // templates
    TPartsFormChatBox
) {
    var VChatBox = Backbone.Epoxy.View.extend({

        template: TPartsFormChatBox,
        events: {
            "click .submit-chatbox": "onSubmit",
            "change .inputfile": "onFileSelect",
            "click .attach-files": "onFileSelectClick",
            "click .attach-picture": "onFileSelectClick",
            'keyup textarea': 'onKeyUp',
            'click #toggle-resize-chatbox': "onToggleResizeChatbox"
        },
        regions: {
            textarea: ".form-control",
            filename: ".filename",
            attachments: '.attachment-chatbox',
            button: '.btn-zone',
            messageReply: ".reply-message",
            cancelReplyButton: ".cancel-reply-button"
        },

        initialize: function(opt) {
            this.attachments = new Backbone.Collection();
            // Weird à vérifier
            this.attachments.hasLeft = function() {
                return false;
            }

            this.options = _.extend({
                name: opt.attribute,
                id: this.cid,
                attachment: true,
                label: 'Send',
                button: true,
                editor: true,
                attachmentClass: 'attach-btn',
                group: opt.group
            }, opt);

            this.view = {
                cancelReplyButton: new VButton({
                    label: "Cancel reply",
                    callback: this.onCancelReplyClick,
                    icon: "fa fa-times",
                    context: this,
                    tcClass: false,
                    class: "btn-xs btn-default",
                }),
                attachmentList: new VAttachmentList({
                    collection: this.attachments
                })
            };

            this.listenTo(ConversationEvents, 'conversation:messageAjaxEnd', this.onMessageAjaxEnd);
            this.listenTo(UserEvents, 'createMeetingClick', this.onCreateMeetingClick);

            this.listenTo(this.attachments, 'add', this.addAttachment);
            this.listenTo(this.attachments, 'remove', this.onRemoveFile);
        },
        render: function() {

            var html = Mustache.render(this.template, Mustache.getContext(this.options));
            this.$el.empty().append(html);
            this.applyBindings();

            this.generateZones();
            if (!this.options.button) {
                this.zone.$button.addClass('hidden');
            }

            if (!this.file) {
                this.toggleAttachment(false);
            }

            this.assign(this.view.cancelReplyButton, this.zone.$cancelReplyButton);
            this.assign(this.view.attachmentList, this.zone.$attachments);

            this.setEditor();

            return this;
        },

        isSupervisor: function() {
            if (this.options.group === undefined) {
                return false;
            } else {
                return this.options.group.isSupervisor();
            }
        },

        toggleDisabled: function(val) {
            this.zone.$textarea.toggleDisabled(val);
        },
        toggleAttachment: function(val) {
            this.zone.$attachments.toggleClass('hidden', !val);
        },

        toggleMessageReply: function(val) {
            this.zone.$messageReply.toggle(val);
        },

        getValue: function() {
            return this.zone.$textarea.summernote('code');
        },

        isEmpty: function() {
            return this.zone.$textarea.summernote('isEmpty');
        },

        getFile: function() {
            return this.attachments.models;
        },

        resetFile: function() {
            this.onRemoveFile();
        },

        setValue: function(value) {
            return this.zone.$textarea.summernote('code', value);
        },

        setFileName: function(filename) {
            this.zone.$filename.text(filename);
            this.toggleAttachment(true);
        },

        setEditor: function() {

            var self = this;

            this.zone.$textarea.summernote({
                dialogsInBody: true,
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['insert', ['link']],
                    ['customButtons', ['messagesTemplate']],
                    ['meetingButton', ['meetingButton']],
                    ['resizeButton', ['resizeButton']],
                ],
                buttons: {
                    messagesTemplate: this.createMessagesButton(self),
                    meetingButton: this.createMeetingButton(self),
                    resizeButton: this.createResizeButton(self)
                },
                disableDragAndDrop: true,
                height: "60px",
                minHeight: "60px",
                maxHeight: "60px",
                callbacks: {
                    onPaste: function(e) {
                        var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text/html');
                        e.preventDefault();
                        var div = $('<div />');
                        div.append(bufferText);
                        div.find('*').removeAttr('style').removeAttr('data-bind');
                        setTimeout(function () {
                            document.execCommand('insertHtml', false, div.html());
                        }, 10);
                    }
                }
            });
        },

        saveEditorMessage: function(context) {

        },

        addEditorMessage: function(title, message) {
            // TODO: Add message to collection (Save)
            this.editorMessages.push({
                title: title,
                value: message
            });

            return this.editorMessages;
        },

        getEditorMessages: function() {
            if (!this.editorMessages) {
                this.editorMessages = [];
                var cCustomMessages = new CCustomMessages();
                cCustomMessages.fetch({
                    async: false,
                    success: _.bind(function(collection, response, options) {
                        cCustomMessages.each(_.bind(function(model, index, list) {
                            this.editorMessages.push({ title: model.get('title'), value: model.get('message') });
                        }, this));
                    }, this),
                    error: function() {
                        this.editorMessages.push({ title: i18n.t("conversation:An error occur while retreiving your custom message"), value: "" });
                    }
                });

                if (this.editorMessages.length === 0) {
                    this.editorMessages.push({ title: i18n.t("conversation:There is no custom message to display"), value: "" });
                }
            }

            return this.editorMessages;

        },

        getEditorMessagesHTML: function() {
            var messages = this.getEditorMessages();
            var html = "";

            Backbone.$(messages).each(function(k, v) {
                html += "<li><a href='#' dataValue='" + k + "' onclick='return false;'>" + this.title + "</a></li>";
            });

            return html;
        },

        createMeetingButton: function(context) {
            if (!this.isSupervisor()) {
                return;
            }

            var ui = Backbone.$.summernote.ui;

            var meetingButton = ui.button({
                className: 'meeting',
                tooltip: i18n.t('conversation:start-a-meeting'),
                contents: '<i class="fa fa-video-camera"></i>',
                click: function() {
                    context.onCreateMeetingClick();
                }
            });

            return meetingButton.render();
        },

        createResizeButton: function(context) {
            var ui = Backbone.$.summernote.ui;

            var resizeButton = ui.button({
                className: 'resize',
                contents: '<i class="sl-icon-size-fullscreen"></i>',
                click: function(a,b,c) {
                    context.$el.find('.note-editable').toggleClass('large');
                    var $element = $(a.target)
                    if ($element.is('button')) {
                        $element = $element.find('i')
                    }
                    if (context.$el.find('.note-editable').hasClass('large')) {
                        $element.removeClass().addClass('sl-icon-size-actual');
                    } else {
                        $element.removeClass().addClass('sl-icon-size-fullscreen');
                    }
                }
            });

            return resizeButton.render();
        },

        createMessagesButton: function(context, btnTrad) {

            if (!this.isSupervisor()) {
                return;
            }

            var editorMessagesHTML = this.getEditorMessagesHTML();
            var editorMessages = this.editorMessages;
            var ui = Backbone.$.summernote.ui;
            var self = this;

            var customMessageButtonGroup = ui.buttonGroup([
                ui.button({
                    className: 'dropdown-toggle ',
                    contents: i18n.t("conversation:Your Messages") + ' <span class="caret"></span>',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                ui.dropdown({
                    className: 'dropdown-menu scrollable-menu three-rows',
                    contents: editorMessagesHTML,
                    callback: function($dropdown) {
                        $dropdown.find('li').each(function() {
                            Backbone.$(this).click(function() {
                                var itemNum = Backbone.$('a', this).attr('dataValue');
                                var text = editorMessages[itemNum];

                                text.value = text.value.replace(/(?:\r\n|\r|\n)/g, '<br />');
                                self.zone.$textarea.summernote('code', text.value);
                            });
                        });
                    }
                })
            ]);

            return customMessageButtonGroup.render();
        },

        destroyEditor: function() {
            this.zone.$textarea.summernote('destroy');
        },

        addAttachment: function(attachment) {
            this.zone.$attachments.append(attachment.get("el"));
        },

        onFileSelect: function(e) {
            var fileList = Array.prototype.slice.call(e.target.files);

            fileList.forEach(function(file) {
                // Different models have different names for attachments
                var attachment = this.model.addAttachment(file);
                this.attachments.push(attachment);
            }, this);

            this.toggleAttachment(true);
        },

        // Reset the input value so the onFileSelect function is triggered when the file is added
        onFileSelectClick: function(e) {
            e.currentTarget.querySelector(".inputfile").value = null;
        },

        onRemoveFile: function(e) {
            if(this.attachments.length == 0) {
                this.toggleAttachment(false);
            }
        },

        onSubmit: function() {
            var options = this.options,
                context = options.context || this,
                model = this.model,
                value = this.zone.$textarea.summernote('code');

            model.set(options.attribute, value);
            
            if(options.attachment) {
                model.set("attachment", this.attachments);
            }

            _.callback(context, options.callback, [model, value]);

            this.trigger("submit", model, value);

            this.oldHtml = this.zone.$button.find('button').html();
            this.zone.$button.find('button').html("<i class='fa fa-spinner fa-spin'></i>").attr('disabled', 'disabled');

            this.zone.$textarea.summernote('code', '');

            // Remove attachments then toggle off
            this.attachments.reset();
            this.toggleAttachment(false);
        },

        onCancelReplyClick: function() {
            this.trigger('cancel:reply');
            this.toggleMessageReply(false);
        },

        onKeyUp: function(e) {
            if (e.keyCode === 13) {
                this.onSubmit();
            }
        },

        onMessageAjaxEnd: function () {
            this.zone.$button.find('button').html(this.oldHtml).removeClass('disabled').removeAttr('disabled');
            if (this.file) this.resetFile();
        },

        onCreateMeetingClick: function() {
            if (!User.get('zoomPersonalMeetingId')) {
                Bootbox.prompt({
                    title: i18n.t('paste-your-pmi'),
                    message: 'asdasd',
                    placeholder: 'ie: 682 278 2812',
                    callback: function(result) {
                        if (result) {
                            var id = result.replace(/\s/g, '').replace(/-/g, '')
                            User.save({ zoomPersonalMeetingId: id }, { patch: true }).then(function() {
                                ToastrService.success('zoom-login-success');
                            });
                        }
                    }
                });
                return;
            }

            (new VZoomMeetingCreatedModal({ meetingId: User.get('zoomPersonalMeetingId'), chatbox: this })).render();
        },

        onToggleResizeChatbox: function() {
            $('.note-editable').toggleClass('large');

            if ($('.note-editable').hasClass('large')) {
                $('#toggle-resize-chatbox').empty().html('<span class="sl-icon-size-actual"></span>');
                $('.message-list .list-content').css('paddingBottom', '250px');
            } else {
                $('#toggle-resize-chatbox').empty().html('<span class="sl-icon-size-fullscreen"></span>');
                $('.message-list .list-content').css('paddingBottom', '10px');
            }
        }
    });

    return VChatBox;

});

